import React from 'react';
import { Menu, X } from 'lucide-react';
import { useMenuState } from '../Common/MenuStateContext';

const isDesktopViewport = () =>
  typeof window !== 'undefined' && window.matchMedia('(min-width: 992px)').matches;

export interface AppTopBarMenuButtonProps {
  className?: string;
}

/** Sidebar collapse (desktop) or drawer open/close (mobile). */
export function AppTopBarMenuButton({ className = '' }: AppTopBarMenuButtonProps) {
  const { isMenuCollapsed, toggleMenuCollapse, isMobileMenuOpen, toggleMobileMenu } =
    useMenuState();

  const onDesktop = isDesktopViewport();
  const isOpen = onDesktop ? !isMenuCollapsed : isMobileMenuOpen;

  const handleClick = () => {
    if (onDesktop) {
      toggleMenuCollapse();
      return;
    }
    toggleMobileMenu();
  };

  const label = onDesktop
    ? isMenuCollapsed
      ? 'Expand sidebar'
      : 'Collapse sidebar'
    : isMobileMenuOpen
      ? 'Close navigation menu'
      : 'Open navigation menu';

  return (
    <button
      type="button"
      className={`app-topbar__menu-btn${className ? ` ${className}` : ''}`}
      onClick={handleClick}
      aria-label={label}
      aria-expanded={isOpen}
      aria-controls="dashboard-sidebar-nav"
    >
      {onDesktop || !isMobileMenuOpen ? <Menu size={18} strokeWidth={1.75} /> : <X size={18} strokeWidth={1.75} />}
    </button>
  );
}

export interface AppTopBarProps {
  title: React.ReactNode;
  dataNav?: string;
  actions?: React.ReactNode;
}

/** EMS-style flat top bar: menu toggle, page title, actions (profile). */
export function AppTopBar({ title, dataNav, actions }: AppTopBarProps) {
  return (
    <header className="app-topbar">
      <div className="app-topbar__start">
        <AppTopBarMenuButton />
        <h1 className="app-topbar__title" data-nav={dataNav}>
          {title}
        </h1>
      </div>
      {actions ? <div className="app-topbar__actions">{actions}</div> : null}
    </header>
  );
}

export default AppTopBar;
